module.exports = __webpack_public_path__ + "static/media/documents.19c030b0.svg";